export default __webpack_public_path__ + "static/media/my-company.13e635ec.svg";